import { apiClient } from './api'

export type EntityType = 'task' | 'project' | 'portfolio' | 'program'

export interface CommentUser {
  id: number
  email: string
  full_name?: string | null
}

export interface Comment {
  id: number
  entity_type: EntityType
  entity_id: number
  user_id: number
  user?: CommentUser | null
  content: string
  mentions?: number[]
  parent_comment_id?: number | null
  created_at: string
  updated_at: string
  deleted_at?: string | null
}

export interface MentionCandidate {
  id: number
  handle: string
  full_name?: string | null
  email: string
}

export const commentsService = {
  list: async (entityType: EntityType, entityId: number): Promise<Comment[]> => {
    const { data } = await apiClient.get('/api/v1/comments/', {
      params: { entity_type: entityType, entity_id: entityId },
    })
    return data
  },

  create: async (
    entityType: EntityType,
    entityId: number,
    content: string,
    parentCommentId?: number,
  ): Promise<Comment> => {
    const { data } = await apiClient.post('/api/v1/comments/', {
      entity_type: entityType,
      entity_id: entityId,
      content,
      parent_comment_id: parentCommentId ?? null,
    })
    return data
  },

  update: async (id: number, content: string): Promise<Comment> => {
    const { data } = await apiClient.patch(`/api/v1/comments/${id}`, { content })
    return data
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/comments/${id}`)
  },

  mentionCandidates: async (query: string): Promise<MentionCandidate[]> => {
    const { data } = await apiClient.get('/api/v1/comments/mention-candidates', {
      params: { q: query },
    })
    return data
  },
}
